import '/assets/styles/sections/header.scss';
import { useState, useEffect } from 'react';
import classNames from 'classnames';

// Partials
import Img from '@wearetla/tla-essentials-tools/partials/img';
import Link from '@wearetla/tla-essentials-tools/partials/link';
import Icon from '@wearetla/tla-essentials-tools/partials/icon';

// Context
import { useModals } from '@wearetla/tla-essentials-tools/utilities/modals';
import { useAuth } from '@wearetla/tla-essentials-tools/utilities/auth';
import { useTranslation } from '/utilities/i18n';

// Sercices
import userServices from '/services/user';

// Static Assets
import image_logo from '/assets/images/logo-white.svg';
import { getLanguage } from '/data/languages';

export const Header = () => {
	const { openModal } = useModals();
	const { loggedIn } = useAuth();
	const { language } = useTranslation();

	const [notificationCount, setNotificationCount] = useState(null);

	const getNotificationCount = () => {
		setNotificationCount(null);
		userServices
			.getNotificationCount()
			.then(setNotificationCount)
			.catch(() => {});
	};

	const readNotifications = () => {
		userServices
			.readAllNotifications()
			.then(() => {
				getNotificationCount();
			})
			.catch(() => {});
	};

	useEffect(() => {
		if (loggedIn) {
			getNotificationCount();
		} else {
			setNotificationCount(null);
		}
	}, [loggedIn]);

	return (
		<>
			<header className="section header">
				<div className="wrapper header-wrap">
					<Link href="home" className="header-logo">
						<Img src={image_logo} lazy={false} className="logo-image" alt="IF Sokak" />
					</Link>

					<button
						type="button"
						className="header-languagebtn"
						onClick={() => {
							openModal('languages');
						}}>
						{getLanguage(language)?.flag} {language.toUpperCase()}
					</button>

					<button
						onClick={() => {
							if (loggedIn) {
								openModal('notifications', { onStare: readNotifications });
							} else {
								openModal('auth');
							}
						}}
						type="button"
						className={classNames('header-notificationsbtn', { highlight: !!notificationCount })}
					>
						<div className="notificationsbtn-wrap">
							<span className="notificationsbtn-count">{notificationCount}</span>
							<Icon className="notificationsbtn-icon" name="notification" />
						</div>
					</button>
				</div>
			</header>
			<div className="section header-placeholder" />
		</>
	);
};

export default Header;
